export { default } from "@workspace/nextjs_utils/src/components/LinkComponent";
